module.exports = __webpack_public_path__ + "help-one-pixel.png";